import { render, staticRenderFns } from "./AdminVehicleEditor.vue?vue&type=template&id=ed9f073c&scoped=true"
import script from "./AdminVehicleEditor.vue?vue&type=script&lang=js"
export * from "./AdminVehicleEditor.vue?vue&type=script&lang=js"
import style0 from "./AdminVehicleEditor.vue?vue&type=style&index=0&id=ed9f073c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9f073c",
  null
  
)

export default component.exports